<div class="textRecordsContainer">
    <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
            <span class="col-3">
            <h5><span class="animateH5">Email Analytics</span></h5>
            </span>
            <span class="col px-0">
                <div class="d-flex justify-content-end">
            <div class="input-group tblSelect">
                    <!-- <select class="form-select audioTableSearchSelect" #columnSelect (change)="selectTableData('column')">
                        <option value="">Select</option>
                        <ng-container *ngIf="filtersColumn.length > 0">
                        <ng-container *ngFor="let column of filtersColumn">
                            <option value="{{column['value']}}" *ngIf="column?.active">{{column['displayName']}}</option>
                        </ng-container>
                        </ng-container>
                    </select> -->
                    <span>
                     <p-select [options]="filtersColumn"  [(ngModel)]="selectedSearchOption" [checkmark]="true" optionValue="value" optionLabel="displayName" placeholder="Select" class="w-full md:w-56" (onChange)="selectTableData('column')" />
                   </span>
                   <span>
                     <p-select [options]="filterCondition"  [(ngModel)]="selectedCondition" [checkmark]="true" optionValue="value" optionLabel="displayName" placeholder="Select" class="w-full md:w-56" (onChange)="selectTableData('condition')" />
                     <!-- <select class="form-select audioTableSearchSelect" #conditionSelect (change)="selectTableData('condition')">
                       <option value="">Select</option>
                        <ng-container *ngIf="filterCondition.length > 0">
                        <ng-container *ngFor="let column of filterCondition">
                            <option value="{{column['value']}}" *ngIf="column['display']">{{column['displayName']}}</option>
                        </ng-container>
                    </ng-container> 
                    </select> -->
                    </span>
                    <!-- <input type="text" class="form-control audioTableSearchInput" *ngIf="selectedSearchOption === 'date'"
                        ngxDaterangepickerMd [autoApply]="true" [showDropdowns]="true" placeholder="Select Date Range"
                        (change)="getDateSearchData($event)" [readonly]="true" /> -->
                        <!-- <input type="date" class="form-control audioTableSearchInput" *ngIf="selectedSearchOption === 'email_date'"
                            placeholder="Select Date"
                        (change)="getDateSearchData($event)"  /> -->
                        <!-- <input type="text" class="form-control audioTableSearchInput" *ngIf="selectedSearchOption === 'email_date'"
                    ngxDaterangepickerMd [autoApply]="true" [showDropdowns]="true" placeholder="mm/dd/yyyy" [singleDatePicker]="true" [locale]="{format: 'DD/MM/YYYY'}"
                    (change)="getDateSearchData($event)" [readonly]="true"  /> -->
                   <span>
                    <ng-container *ngIf="selectedSearchOption === 'email_date'">
                     <p-datepicker   [(ngModel)]="dateRange" placeholder="Select Date" dateFormat="mm-dd-yy" (onClose)="getDateSearchData($event)"   [readonlyInput]="true" showIcon iconDisplay="input" />
                       <!-- <span class="date-wrapper" *ngIf="selectedSearchOption === 'email_date'">
                    <span class="icon"><i class="fa-regular fa-calendar-days"></i></span>
                    <input type="text" class="form-control audioTableSearchInput" 
                    ngxDaterangepickerMd [autoApply]="true" [(ngModel)]="dateRange" [showDropdowns]="true" placeholder="mm/dd/yyyy" [singleDatePicker]="true" [locale]="{format: 'DD/MM/YYYY'}"
                    (change)="getDateSearchData($event)" [readonly]="true"  />  </span>-->
                    </ng-container>
                
                 </span>
                 <span>
                      <!-- <span class="search-wrapper" *ngIf="selectedSearchOption !== 'email_date' && selectedSearchOption !== 'status' && selectedSearchOption!=='sentiment'">
                    <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span>   
                       <input type="text" [(ngModel)]="tableSearch" (ngModelChange)="this.tableSearchUpdate.next($event)"
                       autocomplete="off"  placeholder="Search"  class="form-control audioTableSearchInput" name="searchInput" id="searchInput">
                    </span>   -->
                    <ng-container *ngIf="selectedSearchOption !== 'email_date' && selectedSearchOption !== 'status' && selectedSearchOption!=='sentiment'">
                     <p-iconfield>
                    <p-inputicon styleClass="pi pi-search" />
                    <input type="text" pInputText [(ngModel)]="tableSearch" placeholder="Search"  (input)="tableSearchQuery($event)" />
                    <!-- <p-inputicon *ngIf="tableSearch !=''" styleClass="pi pi-times" (click)="clearSearch()" /> -->
                </p-iconfield>
                </ng-container>
                  </span>
                    <!-- <input type="search" [(ngModel)]="tableSearch" (ngModelChange)="this.tableSearchUpdate.next($event)"
                        autocomplete="off" *ngIf="selectedSearchOption !== 'email_date' && selectedSearchOption !== 'status' && selectedSearchOption!=='sentiment'" placeholder="Search"
                        class="form-control audioTableSearchInput" name="searchInput" id="searchInput">

                    <button class="btn btn-primary audioTableSearchBtn" (click)="getEmailDataFun()"><i
                            class="fa-solid fa-magnifying-glass"></i></button> -->
                             <button class="btn btn-secondary audioTableClearBtn" (click)="refreshData()">
                    <!-- <i class="fa-solid fa-magnifying-glass"></i> -->Clear
                    </button>
            </div>
            </div>
            </span>
        </div>
    </div>
    <div class="container-fluid text-record-main">
     
       
             <!-- <select class="form-select audioTableSearchSelect" #searchSelect (change)="selectTableData()">
                <option value="default">Default</option>
                <option value="keyword">Keyword</option>
                <option value="date">Date Range </option>
            </select>
            <div class="inputContainer">
                <div class="input-group tblSelect">
                    <button class="btn btn-primary audioTableSearchBtn"><i
                            class="fa-solid fa-magnifying-glass"></i></button>
                
                    <input type="search" [(ngModel)]="searchText2" autocomplete="off"
                        *ngIf="selectedSearchOption !== 'date'" placeholder="Search"
                        class="form-control audioTableSearchInput" name="searchInput" id="searchInput">

                </div>
            </div>   -->
            <div class="table-responsive">
                <div class="card tblCrd">
                    <table class="table table-hover text-center">
                        <thead class="tblHead">
                            <tr>
                                <th class="text-start">Agent Name</th>
                                <th class="callCategoryHead">Category</th>
                                <!-- <th class="text-start">Month</th> -->
                                <th class="text-start">email date</th>
                                <th class="text-start">Subject</th>
                               
                                <th class="text-start">Uploaded Date</th>
                                <!-- <th class="text-start">Status</th> -->
                               
                                <th class="">sentiment</th>
                                <th class="progressHead">QA Score</th>
                                <!-- <th class="">Actual Score</th> -->
                                <th class=""> Email</th>
                                <!-- <th>REPORT</th> -->
                                <!-- <th class="timeTh" (click)="sortFun()">uploaded date
                                    <i class="fa fa-sort-asc" *ngIf="!sortingShow" aria-hidden="true"></i>
                                    <i class="fa fa-sort-desc" *ngIf="sortingShow" aria-hidden="true"></i>
                                </th> -->
                                <th class="action">action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center" *ngIf="emailData.length === 0 && !bodySpinner">
                                <td colspan="13">
                                    <p class="noRecord">No Records Found</p>
                                </td>
                            </tr>
                            <tr *ngFor="let result of emailData | search: searchText2 | paginate :{itemsPerPage:limit,
                                currentPage:page,
                                totalItems:total_records}; index as i" (click)="tableBack(i)"
                                [ngClass]="{'selectedClass':i===tableTrVar, 'isRepeat': result.isrepeat==='Y'}">
                                <td class="text-start">{{result.agent_name}}</td>
                                <!-- <td class="text-start">{{result.month}}</td> -->
                                  <td class="callCategoryTd">
                                  
    
                                    <span class="categoryPara-null" *ngIf="result.categories.length === 0">-</span>
                                    <span class="score-progress" *ngIf="result.categories.length !== 0">
                                        <span class="categoryPara" *ngIf="result.categories?.length !==0"
                                             >{{result.categories[0].category_name}}</span>
                                        <span class="categoryPara-null" *ngIf="result.categories.length ===0">-</span>
                                        <i class="fa fa-eye" aria-hidden="true" tooltip="View Category Details"
                                            [options]="myOptions" data-bs-toggle="modal" data-bs-target="#callCategoryModal"
                                            (click)="CallCategoryIndex(i)"></i>
                                    </span>
                                </td>
                                <td class="text-start">
                                    <ng-container *ngIf="result?.email_date==null else emailDateData">
                                        <span> - </span>
                                    </ng-container>
                                    <ng-template #emailDateData>
                                     <span> {{result.email_date | date:'MMM d, y' }}</span>
                                    </ng-template>
                                   </td>
                                <td class="text-start subject">
                                    <ng-container *ngIf="result?.subject=='' else subjectData">
                                        <span> - </span>
                                    </ng-container>
                                    <ng-template #subjectData>
                                     <span appReadMore [toggle]="true" [limit]="50"   title="{{result.subject}}">{{result.subject}}</span>
                                    </ng-template>
                                    
                                </td>
                                <!-- <td class="text-start">{{result.case_id}}</td>
                                <td class="text-start">{{result.sub_attribute}}</td>
                                <td class="text-start">{{result.type}}</td> -->
                                <td class="text-start">{{result.created_at | date:'MMM d, y'}}</td> 
                                <!-- <td class="text-start">{{result.status}}</td> 
                                <td class="text-start">{{result.team}}</td>-->
                                <td>
                                    <i class="fa-regular fa-face-meh audioIcons iconMeh" *ngIf="result.sentiment=='Neutral'"
                                    tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                    (click)="getSentimentFun(i)" ></i>
                                        <i class="fa-regular fa-face-smile audioIcons iconSmile" *ngIf="result.sentiment=='Positive'"
                                    tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                    (click)="getSentimentFun(i)"  ></i>
                                        <i class="fa-regular fa-face-frown audioIcons iconSad" *ngIf="result.sentiment=='Negative'"
                                        tooltip="View Sentiment" [options]="myOptions" data-bs-toggle="modal"  data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)"    ></i>
                                        
                                </td>
                             
                                <!-- <td><i *ngIf="result.negative_sentiment < result.positive_sentiment"
                                        class="fa-regular fa-face-smile audioIcons iconSmile"
                                        tooltip="View Sentiment Score" [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#sentimentModal" (click)="getSentimentFun(i)"
                                        (click)="sentimentHeading('overall')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    <i *ngIf="result.positive_sentiment === result.negative_sentiment"
                                        class="fa-regular fa-face-meh audioIcons iconMeh" tooltip="View Sentiment Score"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#sentimentModal"
                                        (click)="getSentimentFun(i)" (click)="sentimentHeading('overall')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                    <i *ngIf="result.positive_sentiment < result.negative_sentiment"
                                        class="fa-regular fa-face-frown audioIcons iconSad"
                                        tooltip="View Sentiment Score" [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#sentimentModal" (click)="getSentimentFun(i)"
                                        (click)="sentimentHeading('overall')"
                                        (click)="sentimentWordsHeading('positive')"></i>
                                </td> -->
                                <!--                                 
                                <i class="fa fa-smile-o green-clr" data-toggle="modal" data-target="#sentimentDetails" tooltip="View Sentiment Score" placement="top" (click)="showSentiment(data)" 
                                 *ngIf="data.negative_sentiment[0] < data.positive_sentiment[0] && data.neutral_sentiment[0] < data.positive_sentiment[0]"></i>
                                <i class="fa fa-frown-o red-clr" data-toggle="modal" data-target="#sentimentDetails" tooltip="View Sentiment Score" placement="top" (click)="showSentiment(data)"
                                 *ngIf="data.positive_sentiment[0] < data.negative_sentiment[0] && data.neutral_sentiment[0] < data.negative_sentiment[0]"></i>
                                <i class="fa fa-meh-o yellow-clr" data-toggle="modal" data-target="#sentimentDetails" tooltip="View Sentiment Score" placement="top" (click)="showSentiment(data)"
                                 *ngIf="data.positive_sentiment[0] < data.neutral_sentiment[0] && data.negative_sentiment[0] < data.neutral_sentiment[0] || data.positive_sentiment[0] === data.negative_sentiment[0]"></i> -->
                                <td class="progressTd">
                                    <div class="progress">
                                        <div [ngClass]="{'progress-bar0': result.qa_score == 0, 'progress-barGreen':result.qa_score > 74, 'progress-barRed':result.qa_score > 0 && result.qa_score < 50}"
                                            class="progress-bar" role="progressbar"
                                            attr.style="width:{{result.qa_score}}%"
                                            attr.aria-valuenow="{{result.qa_score}}"
                                            attr.aria-valuemin="{{0}}" aria-valuemax="100">{{result.qa_score | number:'1.0-0'}}%</div>
                                    </div>
                                     <i class="fa fa-eye" aria-hidden="true" tooltip="View QA Score"
                                    [options]="myOptions" data-bs-toggle="modal"
                                    data-bs-target="#qaMetricsModal"
                                    (click)="getQAMetricsData(i)"></i>  
                                </td>
                                <!-- <td class="">{{result?.actual_score}}</td> -->
                                <td>
                                    <i class="fa fa-envelope audioIcons iconFile" data-bs-toggle="modal"
                                    data-bs-target="#emailBodyModal" (click)="modalHeading('customerMail')"
                                    tooltip="View Email" [options]="myOptions" (click)="getEmailBody(i)"
                                    ></i>
                                    <!-- <i class="fa fa-envelope audioIcons iconFile" data-bs-toggle="modal"
                                        data-bs-target="#transcriptModal" tooltip="View Transcript"
                                        [options]="myOptions" (click)="modalHeading('dialogue')"
                                        (click)="getTranscriptFun(i, 'transcriptModal')"
                                        (click)="hideMinimizedModal('Transcript')"></i> -->
                                    </td>
                 
                                <td class="actionTd">
                                    <!-- <i class="fa-regular fa-share-from-square audioIcons iconAction"
                                        tooltip="Auto Escalate" [options]="myOptions" data-bs-toggle="modal"
                                        data-bs-target="#emailEscalateModal"
                                        (click)="getTranscriptFun(i, 'otherModal')"></i> -->
                                    <i class="fa-solid fa-reply audioIcons iconAction" data-bs-toggle="modal"
                                        data-bs-target="#emailReplayModal" (click)="getEmailReply(i)"
                                        
                                   tooltip="Bot Reply" [options]="myOptions"></i>  
                                        <!-- <i class="fa-solid fa-reply audioIcons iconAction" data-bs-toggle="modal"
                                        data-bs-target="#emailReplayModal" (click)="getTranscriptFun(i, 'otherModal')"
                                        tooltip="Bot Reply" [options]="myOptions"></i> -->
                                    <i class="fa-regular fa-trash-can audioIcons iconAction" tooltip="Delete Record"
                                        [options]="myOptions" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                        (click)="getIndex(i)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="paginationRecords" *ngIf="emailData.length > 0">
                <div class="d-flex align-items-center">
                    <span class="col-md-6 pagination-records">
                        Showing {{emailData.length}} of {{total_records}} records
                    </span>
                    <span class="col-md-6 pull-right">
                       
                            <pagination-controls #pagination [maxSize]="7" [responsive]="true" [autoHide]="true"
                                [directionLinks]="true" (pageChange)="pageChanged($event)">

                            </pagination-controls>
                        
                    </span>
                </div>
            </div>
            
    </div>
    <!-- minimize modal -->
    <div class="minimized-transcript-modal" *ngIf="transcriptMinimizedBoolean">
        <div class="modal-header">
            <h4 class="modal-title">{{transcriptMinimizedHeader}}</h4>
            <div class="modal-header-second-part">
                <i class="fa-solid fa-maximize min-max-icon" data-bs-toggle="modal" data-bs-target="#transcriptModal"
                    (click)="hideMinimizedModal('Transcript')" tooltip="Maximize" [options]="myOptions"></i>
                <i class="fa-solid fa-xmark exitIcon close " tooltip="Close" [options]="myOptions"
                    (click)="clearKeywordDetailsTranscriptModal()" aria-label="Close"
                    (click)="hideMinimizedModal('Transcript')"></i>
            </div>
        </div>
    </div>
    <!-- Modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="transcriptModal">
        <div class="modal-dialog modal-dialog-scrollable modal-xl {{modalScreenSize}} transcriptModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Transcript</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-window-minimize min-max-icon" title="Minimize"
                            (click)="showMinimizedModal('Transcript')" data-bs-dismiss="modal" aria-label="Close"></i>
                        <i class="fa-solid fa-up-right-and-down-left-from-center min-max-icon" title="Full Screen"
                            *ngIf="!modalScreenSize" (click)="modalFullScreen('max')"></i>
                        <i class="fa-solid fa-down-left-and-up-right-to-center min-max-icon" title="Restore Down"
                            *ngIf="modalScreenSize" (click)="modalFullScreen('min')"></i>
                        <i class="fa-solid fa-xmark exitIcon close " title="Close"
                            (click)="clearKeywordDetailsTranscriptModal()" data-bs-dismiss="modal"
                            aria-label="Close"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-pills nav-justified border-bottom modalTitileTab" role="tablist">
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'dialogue'}" href="#nav-dialogue"
                                data-bs-toggle="tab" id="dialogue" role="tab" (click)="modalHeading('dialogue')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')" aria-current="page">Dialogue</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'keyword'}" href="#nav-keyword"
                                #keywordId data-bs-toggle="tab" id="keyword" role="tab"
                                (click)="modalHeading('keyword')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Keyword/Phrases</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'alertKeywords'}"
                                href="#nav-alertKeywords" data-bs-toggle="tab" role="tab" id="alertKeywords"
                                (click)="modalHeading('alertKeywords')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Alert Keywords</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'questions'}" href="#nav-questions"
                                data-bs-toggle="tab" role="tab" id="questions" (click)="modalHeading('questions')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Questions</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'summary'}" href="#nav-summary"
                                data-bs-toggle="tab" role="tab" id="summary" (click)="modalHeading('summary')"
                                (click)="getTranscriptFun(fileIndex, 'questions')">Summary</a>
                        </li>
                        <li class="nav-item border-end border-bottom border-2">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'mostUsedWords'}"
                                href="#nav-mostUsedWords" data-bs-toggle="tab" role="tab" id="mostUsedWords"
                                (click)="modalHeading('mostUsedWords')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Most Used Words</a>
                        </li>
                        <li class="nav-item border-bottom border-2 modalTitile" *ngIf="showData === 'pdf' ">
                            <a class="nav-link" [ngClass]="{'active':showModal === 'textEntities'}"
                                href="#nav-textEntities" data-bs-toggle="tab" role="tab" id="textEntities"
                                (click)="modalHeading('textEntities')"
                                (click)="getTranscriptFun(fileIndex, 'transcript')">Text Entities</a>
                        </li>
                    </ul>
                    <div class="modal-subtitle modal-subtitle2 border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'dialogue'">
                                        Dialogue</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'transcript'">Transcript</h4>
                                    <h4 class="tabContentHeading"
                                        *ngIf="showModal === 'keyword' && !spinner && showData !== 'emailTable'">
                                        Keyword/Phrases
                                        {{" - Keyword Percentage - "+"( "+(questionsData_T[0]?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <h4 class="tabContentHeading"
                                        *ngIf="showModal === 'keyword' && !spinner && showData === 'emailTable'">
                                        Keyword/Phrases
                                        {{" - Keyword Percentage - "+"( "+(questionsData_T?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'alertKeywords'">Alert
                                        Keywords
                                    </h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'questions'">Questions</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'summary'">Summary</h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'mostUsedWords'">Most Used
                                        Words
                                    </h4>
                                    <h4 class="tabContentHeading" *ngIf="showModal === 'textEntities'">Text Entities
                                    </h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable_T"
                                        name="" id="" class="form-select lg-select-transcript"
                                        *ngIf="showSelect_T && !spinner">
                                        <option *ngFor="let lg of transcribedLg_T" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Dialogue Contents -->
                    <div class="tab-content">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'dialogue','show':showModal === 'dialogue'}"
                            id="nav-dialogue" *ngIf="!spinner">
                            <p *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emaildate"
                                class="emailTranscriptHeading3 text-end"><b>{{emailData[fileIndex]?.emaildate}}</b>
                            </p>
                            <p *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emailsubject"
                                class="emailTranscriptHeading2"><b>{{emailData[fileIndex]?.emailsubject}}</b></p>
                            <div class="transcriptTab emailTableTranscriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.emailfrom ">
                                <span><b>From: </b> {{emailData[fileIndex]?.emailfrom}}</span>
                            </div>
                            <div class="transcriptTab email-transcriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.emailto.length > 0 ">
                                <b>To: </b>
                                <ul class="emailTableTranscriptTab"
                                    *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                    <span> {{to}}</span>
                                </ul>
                            </div>
                            <div class="transcriptTab email-transcriptTab"
                                *ngIf="dialogueList_T?.[0] && showData == 'emailTable' && emailData[fileIndex]?.cc.length > 0">
                                <b>CC: </b>
                                <ul class="emailTableTranscriptTab"
                                    *ngFor="let cc of emailData[fileIndex]?.cc; index as cc_i">
                                    <span> {{cc}}</span>
                                </ul>
                            </div>
                            <div class="transcriptTab" *ngIf="dialogueList_T?.[0]">
                                <ul class="ulTranscript-textRecords" *ngFor="let dialog of dialogueList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi">{{dialog}}</li>
                                </ul>
                            </div>
                            <div class="transcriptTab" *ngIf="!dialogueList_T?.[0]">
                                <p class="noRecord text-center">No records found</p>
                            </div>
                        </div>
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'keyword','show':showModal === 'keyword'}"
                            id="nav-keyword" *ngIf="!spinner">
                            <!--Keyword/Phrases-->
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul *ngFor="let keyword of keywordPhrases_T ; index as i;" [appHighlight]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="keywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul *ngFor="let keyword of keywordPhrases_T ; index as i;" [appHighlight]="searchText"
                                    class="border-bottom">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- AlertKeyword -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'alertKeywords','show':showModal === 'alertKeywords'}"
                            id="nav-alertKeywords" *ngIf="!spinner">
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T === 'English' ">
                                <ul class="border-bottom" *ngFor="let keyword of alertkeywordList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="alertkeywordTab" *ngIf="transcribedLgVariable_T !== 'English' ">
                                <ul class="border-bottom" *ngFor="let keyword of alertkeywordList_T ; index as i;"
                                    [appHighlight]="searchText">
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T === 'English' ">
                                        {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                            No matches were found for keyword -
                                            "{{keyword.keyword}}"</p>
                                    </li>
                                    <li class="keywordLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                    <li class="matchesLi" *ngIf="transcribedLgVariable_T !== 'English' ">
                                        {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                            class="text-center">No matches were found for keyword -
                                            "{{keyword.spanish_keyword}}"</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- question tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'questions','show':showModal === 'questions'}"
                            id="nav-questions">
                            <div class="questionTab2" *ngIf="englishQuestions_T?.length == 0">
                                <p class="noRecord">No Records Found</p>
                            </div>
                            <div class="questionTab" *ngIf="englishQuestions_T?.length > 0">
                                <table>
                                    <tbody>
                                        <tr *ngFor="let question of englishQuestions_T ; index as i;"
                                            [appHighlight]="searchText">
                                            <td class="numberTd">{{i+1}}.</td>
                                            <td>
                                                <p class="answerPara">
                                                    <b>{{"Q : "}}</b>
                                                    {{question.question}}
                                                </p>
                                                <p> <b>{{"A : "}}</b>
                                                    {{question.answer}}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- summary tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'summary','show':showModal === 'summary'}"
                            id="nav-summary" *ngIf="!spinner">
                            <div class="summaryTab">
                                <p *ngFor="let sum of keywordSummary_T;" [appHighlight]="searchText">{{sum}}</p>
                                <p class="noRecord text-center" *ngIf="!keywordSummary_T?.length">No records found
                                </p>
                            </div>
                        </div>
                        <!-- most used words tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'mostUsedWords','show':showModal === 'mostUsedWords'}"
                            id="nav-mostUsedWords" *ngIf="!spinner">
                            <div class="mostUsedWordTab">
                                <p class="data" *ngFor="let word of mostUsedWords_T ; index as i;"
                                    [appHighlight]="searchText">
                                    {{i+1}}.
                                    {{word.word}}
                                    ({{word.count}})</p>
                                <p class="noRecord text-center" *ngIf="!mostUsedWords_T?.length">No records found
                                </p>
                            </div>
                        </div>
                        <!--  text entities tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active':showModal === 'textEntities','show':showModal === 'textEntities'}"
                            id="nav-textEntities" *ngIf="!spinner">
                            <div class="col-md-12 text-entities-button-class"
                                *ngIf="transcribedLgVariable_T === 'English' ">
                                <button class="btn btn-primary updateBtn"
                                    (click)="DownloadEntityData()">Download</button>
                            </div>
                            <div class="mostUsedWordTab">
                                <div *ngIf="transcribedLgVariable_T === 'English' ">
                                    <p class="data" *ngFor="let result of textEntitiesResult_T ; index as i;"
                                        [appHighlight]="searchText">
                                        {{result.propertyKey + " : "}} {{result.propertyValue}}
                                    </p>
                                    <p class="noRecord text-center" *ngIf="!textEntitiesResult_T?.length">No records
                                        found
                                    </p>
                                </div>
                                <div class="noRecord text-center" *ngIf="transcribedLgVariable_T !== 'English' ">No
                                    records found</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Keyword Percentage Modal Window -->
    <div class="modal fade" id="keywordPercentageModal" tabindex="-1" aria-labelledby="keywordPercentageModal"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="keywordPercentageModalLabel">Keyword Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="modal-subtitle border-bottom">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-8 tab-head">
                                    <h4 class="tabContentHeading" *ngIf="!spinner">Keyword/Phrases
                                        {{"( "+ (questionsData[0]?.keywords_percentage |
                                        number:'1.0-1')+"% )" }}</h4>
                                    <select (change)="changeTranscriptLgFun()" [(ngModel)]="transcribedLgVariable"
                                        name="" id="" class="form-select lg-select-transcript" *ngIf="showSelect">
                                        <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-md-4 tab-head search-input-tab-head">
                                    <input type="search" class="form-control" placeholder="search keywords"
                                        [(ngModel)]="searchText">
                                    <i class="fa-solid fa-magnifying-glass userSearchLens"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="nav-keyword" *ngIf="!spinner">
                        <!--Keyword/Phrases-->
                        <div class="keywordTab">
                            <ul *ngFor="let keyword of keywordPhrases | search: searchText; index as i">
                                <li class="keywordLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable === 'English' ">
                                    {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1" class="text-center">
                                        No matches were found for keyword -
                                        "{{keyword.keyword}}"</p>
                                </li>
                                <li class="keywordLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}</li>
                                <li class="matchesLi" *ngIf="transcribedLgVariable !== 'English' ">
                                    {{keyword.spanish_matches}} <p *ngIf="keyword.spanish_matches?.length < 1"
                                        class="text-center">No matches were found for keyword -
                                        "{{keyword.spanish_keyword}}"</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- QA Metrics Modal Window -->
    <!-- <div class="modal fade" id="qaMetricsModal" tabindex="-1" aria-labelledby="qaMetricsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="qaMetricsModalLabel">Metric Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearModalData()"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Metric Details (Metric Percentage - {{getMetricPercentage | number:'1.0-0'}}%)</p>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="3" class="text-center"></th>
                                            <th colspan="3" class="text-center">Machine Scores based on QA Metric
                                            </th>
                                        </tr>
                                        <tr>
                                            <th>Category</th>
                                            <th>Score</th>
                                            <th>Keywords</th>
                                            <th>Agent Score</th>
                                            <th>Percentage (%)</th>
                                            <th>Matched Keywords</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center" *ngIf="metricsMatches.length === 0">
                                            <td colspan="8">
                                                <p class="noRecord">No Records Found</p>
                                        </tr>
                                        <tr *ngFor="let call of metricsMatches; index as i">
                                            <td>{{call?.category}}</td>
                                            <td>{{call?.score}}</td>
                                            <td>{{call?.keywords}}</td>
                                            <td>{{call?.agent_score}}</td>
                                            <td>{{call?.matched_percentage | number:'1.0-1'}}%</td>
                                            <td>{{call?.matched_keywords}}
                                                <p class="text-center" *ngIf="!call?.matched_keywords.length">-</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Modulation Modal Window -->
    <div class="modal fade" id="modulationModal" tabindex="-1" aria-labelledby="modulationModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="modulationModalLabel">Modulation Details</h4>
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p *ngIf="this.showData === 'pdf'">Modulation Details (Modulation Percentage -
                                {{tableData[callCategoryIndex]?.pause_score |
                                number:'1.0-0'}}%)</p>
                            <p *ngIf="this.showData === 'text'">Modulation Details (Modulation Percentage -
                                {{textTableData[callCategoryIndex]?.pause_score |
                                number:'1.0-0'}}%)</p>

                        </div>
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Negative Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.negative?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.negative; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.1'}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="2">Positive Modulation</th>
                                    </tr>
                                    <tr>
                                        <th>Word</th>
                                        <th>Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="modulationData?.positive?.length === 0">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <tr *ngFor="let call of modulationData?.positive; index as i">
                                        <td>{{call?.word}}</td>
                                        <td>{{call?.score | number:'1.0-1'}}%</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Record Info Edit Modal Window -->
    <div class="modal fade" id="RecordDeleteModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="RecordDeleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" *ngIf="showData === 'pdf' " id="RecordDeleteModalLabel">PDF Details</h4>
                    <h4 class="modal-title" *ngIf="showData === 'text' " id="RecordDeleteModalLabel">Text Details
                    </h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearRecordData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="infoHeading d-flex border-bottom">
                        <p class="infoFirst"> <b>Details</b></p>
                        <button class="btn infoSecond" (click)="editInfoDetails()">
                            <i *ngIf="!infoEditShow" class="fa-regular fa-pen-to-square" tooltip="Edit Info"
                                [options]="myOptions"></i>
                            <i *ngIf="infoEditShow" class="fa fa-arrow-left" aria-hidden="true" tooltip="Back"
                                [options]="myOptions"></i>
                        </button>
                    </div>
                    <form [formGroup]="infoForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label mandatoryLabel"><b>Display Name</b><i
                                                class="fa-solid fa-asterisk mandatoryIcon"
                                                *ngIf="infoEditShow"></i></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetails?.display_file_name}}</p>
                                    <input *ngIf="infoEditShow" formControlName="display_file_name"
                                        name="display_file_name" id="display_file_name" type="text"
                                        class="form-control">
                                    <span class="text-danger"
                                        *ngIf="infoForm.controls['display_file_name'].invalid && infoForm.controls['display_file_name'].dirty && infoForm.hasError('required','display_file_name')">
                                        Display name is Required.
                                    </span>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Topics</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoTopicsName}}</p>

                                    <ng-select *ngIf="infoEditShow" formControlName="topic" dropdownPosition="auto"
                                        name="topic" id="topic" placeholder="Choose/Search topic" [clearable]="false">
                                        <ng-option [value]="info.id?.$oid" title="{{info?.id?.$oid}}"
                                            *ngFor="let info of getInfoTopics; index as i">{{info?.topic}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Your Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.own_key_words">{{infoDetails?.own_key_words}}</span>
                                        <span *ngIf="!infoDetails?.own_key_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="own_key_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="own_key_words"
                                        name="own_key_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Alert Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.alert_keywords">{{infoDetails?.alert_keywords}}</span>
                                        <span *ngIf="!infoDetails?.alert_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="alert_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="alert_keywords"
                                        name="alert_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Sensitive Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span
                                            *ngIf="infoDetails?.sensitive_words">{{infoDetails?.sensitive_words}}</span>
                                        <span *ngIf="!infoDetails?.sensitive_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="sensitive_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal"
                                        id="sensitive_words" name="sensitive_words" autocomplete="off"
                                        [disable]="disableInput" [addOnPaste]="true" [pasteSplitPattern]="splitPattern">
                                    </tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Hide Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.hide_keywords">{{infoDetails?.hide_keywords}}</span>
                                        <span *ngIf="!infoDetails?.hide_keywords?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="hide_keywords"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="hide_keywords"
                                        name="hide_keywords" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Delete Keywords</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.delete_words">{{infoDetails?.delete_words}}</span>
                                        <span *ngIf="!infoDetails?.delete_words?.length"><b>-</b></span>
                                    </p>
                                    <tag-input *ngIf="infoEditShow" formControlName="delete_words"
                                        class="form-control tagInput-form-control" placeholder="Keyword"
                                        secondaryPlaceholder="Enter Your Keyword" [trimTags]="true" [addOnBlur]="true"
                                        [clearOnBlur]="true" [modelAsStrings]="true" theme="minimal" id="delete_words"
                                        name="delete_words" autocomplete="off" [disable]="disableInput"
                                        [addOnPaste]="true" [pasteSplitPattern]="splitPattern"></tag-input>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Comments</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection">
                                    <p class="infoData" *ngIf="!infoEditShow">
                                        <span *ngIf="infoDetails?.conversation">{{infoDetails?.conversation}}</span>
                                        <span *ngIf="!infoDetails?.conversation"><b>-</b></span>
                                    </p>
                                    <textarea *ngIf="infoEditShow" formControlName="conversation" type="text"
                                        class="form-control" placeholder="Enter all audit comment"></textarea>
                                </div>
                                <div class="col-md-3 offset-md-1 formSection">
                                    <div class="form-group">
                                        <label class="form-label"><b>Language</b></label>
                                    </div>
                                </div>
                                <div class="col-md-7 formSection language-form-group">
                                    <p class="infoData" *ngIf="!infoEditShow">{{infoDetailsLanguage}}</p>
                                    <ng-select *ngIf="infoEditShow" [attr.disabled]="true" [readonly]="true"
                                        formControlName="language" type='text' placeholder="Choose Language">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="infoEditShow" (click)="clearRecordData()"
                        class="btn btn-light cancelBtn" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" [disabled]="!infoForm.dirty || infoForm.invalid" *ngIf="infoEditShow"
                        class="btn btn-primary updateBtn" (click)="updateInfoDetails()" data-bs-dismiss="modal"
                        (click)="clearRecordData()">Update</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Report Modal -->
    <div class="modal fade reportModalClass" #reportModalContent data-bs-backdrop="static" data-bs-keyboard="false"
        id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="reportModalLabel">Review / Analysis</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="container-fluid">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="reportFirstPart d-flex language-form-group">
                                        <select (change)="changeTranscriptLgReport()"
                                            [(ngModel)]="transcribedLgVariable" name="" id=""
                                            class="form-select lg-select-transcript" *ngIf="showSelect && !spinner">
                                            <option *ngFor="let lg of transcribedLg" [value]="lg">{{lg}}
                                            </option>
                                        </select>
                                        <button class="btn updateBtn" (click)="makePDF()"
                                            [disabled]="downloadBtnSpinner"><i *ngIf="downloadBtnSpinner"
                                                class="fa fa-spinner fa-pulse fa-3x fa-fw download-spinner"></i>
                                            <span class="sr-only">Loading...</span> Download Report</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportSecondPart">
                            <div class="col-md-8 offset-md-3">
                                <table id="report-top-details" class="reportTable" style="display: none;">
                                    <thead style="display: none;">
                                        <tr>
                                            <th colspan="4">Report Details - {{dateTime | date:'shortDate'}} </th>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td> <label class="form-label first-label"><b>File Uploaded Date
                                                    </b></label> </td>
                                            <td> <span class="form-detail"> {{infoDetails?.updated_date |
                                                    date:'shortDate'}}</span> </td>
                                            <td> <label class="form-label second-label"><b>Call Queue/Topic
                                                    </b></label> </td>
                                            <td> <span> {{infoDetails?.display_file_name}}</span> </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class="col-md-4">
                                        <label class="form-label"><b>File Uploaded Date : </b></label>
                                        <span> {{infoDetails?.updated_date | date:'shortDate'}}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="form-label"><b>Call Queue/Topic : </b></label>
                                        <span> {{infoDetails?.display_file_name}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- sss -->
                        <div class="col-md-6 offset-md-3">
                            <div class="card modalCard2" id="sentimentCard2" style="display: none;">
                                <div class="card-header">
                                    <p class="sentiment-header"> Sentiment</p>
                                </div>
                                <table id="sentiment-table-report">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="card-body">
                                                    <ul class="list-group list-group-horizontal">
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.positive_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Positive</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.neutral_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Neutral</p>
                                                        </li>
                                                        <li class="list-group-item secondList">
                                                            <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                            <p class="sentiment-score">
                                                                {{infoDetails?.negative_sentiment?.[0] |
                                                                number:'1.0-1'}}%</p>
                                                            <p class="sentiment-name">Negative</p>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!--  -->
                        <div class="row reportThirdPart">
                            <div class="col-md-6 offset-md-3">
                                <div class="card modalCard" id="sentimentCard">
                                    <div class="card-header">
                                        <p class="sentiment-header"> Sentiment</p>
                                    </div>
                                    <div class="card-body">
                                        <ul class="list-group list-group-horizontal">
                                            <li class="list-group-item">
                                                <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.positive_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Positive</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.neutral_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Neutral</p>
                                            </li>
                                            <li class="list-group-item">
                                                <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                                <p class="sentiment-score">
                                                    {{infoDetails?.negative_sentiment?.[0] |
                                                    number:'1.0-1'}}%</p>
                                                <p class="sentiment-name">Negative</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row reportFourthPart">
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Question/Answer
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="questionTab" *ngIf="englishQuestions?.length > 0">
                                            <table id="question-answer-report">
                                                <thead style="display: none;">
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        *ngFor="let question of englishQuestions | search: searchText; index as i">
                                                        <td class="numberTd">{{i+1}}.</td>
                                                        <td>
                                                            <p class="answerPara">
                                                                <b>{{"Q : "}}</b>
                                                                {{question.question}}
                                                            </p>
                                                            <p> <b>{{"A : "}}</b>
                                                                {{question.answer}}</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="questionTab2" *ngIf="englishQuestions?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                            <table id="question-answer-report" style="display: none;">
                                                <thead>
                                                    <tr>
                                                        <td colspan="2">Question/Answer</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard keywordPhrasesCard">
                                    <div class="card-header">
                                        Keywords/Phrases
                                    </div>
                                    <div class="card-body keywordTabCardBody">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="keywordTab" id="keyword-phrases-table-report"
                                            *ngIf="keywordPhrases?.length > 0">
                                            <tbody>
                                                <tr
                                                    *ngFor="let keyword of keywordPhrases | search: searchText; index as i">
                                                    <td>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            {{keyword.keyword}}{{"("+keyword.count+")"}}</li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable === 'English' ">
                                                            {{keyword.matches}} <p *ngIf="keyword.matches?.length < 1"
                                                                class="text-center">
                                                                No matches were found for keyword -
                                                                "{{keyword.keyword}}"</p>
                                                        </li>
                                                        <li class="keywordLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            {{keyword.spanish_keyword}}{{"("+keyword.count+")"}}
                                                        </li>
                                                        <li class="matchesLi"
                                                            *ngIf="transcribedLgVariable !== 'English' ">
                                                            {{keyword.spanish_matches}} <p
                                                                *ngIf="keyword.spanish_matches?.length < 1"
                                                                class="text-center">No matches were found for
                                                                keyword -
                                                                "{{keyword.spanish_keyword}}"</p>
                                                        </li>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="questionTab2" *ngIf="keywordPhrases?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                            <table class="keywordTab" id="keyword-phrases-table-report"
                                                style="display: none;">
                                                <tbody>
                                                    <tr>
                                                        <td colspan="2">
                                                            <p class="noRecord">No Records Found</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard dialogue-text-record-report">
                                    <div class="card-header">
                                        Dialogue
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <table class="table" id="transcriptReport" *ngIf="dialogueList?.[0]">
                                            <thead style="display: none;">
                                                <tr>
                                                    <th>
                                                        Dialogue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let dialog of dialogueList  | search: searchText; index as i">
                                                    <td class="report-dialog">{{dialog}}</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="table" id="transcriptReport" *ngIf="!dialogueList?.[0]">
                                            <thead style="display: none;">
                                                <tr>
                                                    <th>
                                                        Dialogue
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="noRecord text-center">No records
                                                            found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Summary
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="summaryTab">
                                            <p class="data" *ngFor="let sum of keywordSummary | search: searchText">
                                                {{sum}}</p>
                                            <p class="noRecord text-center" *ngIf="!keywordSummary?.length">No
                                                records
                                                found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card modalCard">
                                    <div class="card-header">
                                        Most Used Words
                                    </div>
                                    <div class="card-body">
                                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                                        <span class="sr-only">Loading...</span>
                                        <div class="mostUsedWordTab" *ngIf="mostUsedWords?.length > 0">
                                            <table id="most-used-words-table-report">
                                                <tbody>
                                                    <tr
                                                        *ngFor="let word of mostUsedWords | search: searchText; index as i">
                                                        <td>
                                                            <p class="data">
                                                                {{i+1}}.
                                                                {{word.word}}
                                                                ({{word.count}})</p>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="questionTab2" *ngIf="mostUsedWords?.length == 0">
                                            <p class="noRecord">No Records Found</p>
                                        </div>
                                        <table id="most-used-words-table-report" style="display: none;">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        Most Used Words
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p class="noRecord">No Records Found</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 offset-md-3">
        <div class="card modalCard2" id="sentimentCard3" style="display: none;">
            <div class="card-header">
                <p class="sentiment-header"> Sentiment</p>
            </div>
            <table id="sentiment-table-report">
                <tbody>
                    <tr>
                        <td>
                            <div class="card-body">
                                <ul class="list-group list-group-horizontal">
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.positive_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.neutral_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Neutral</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.negative_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- Sentiment Modal  -->
    <div class="modal fade" id="sentimentModal">
        <div class="modal-dialog modal-dialog-scrollable modal-lg sentimentModalWindow">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Sentiment Summary</h4>
                    <i class="fa-solid fa-xmark exitIcon" (click)="clearSentimentData()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="tab-content">
                        <!-- overall tab -->
                        <div class="tab-pane"
                            [ngClass]="{'active': showsentiment === 'overall', 'show': showsentiment === 'overall'}"
                            id="overallSentiment">
                            <div class="sentiment-container-emoji">
                                <ul class="list-group list-group-horizontal border" *ngIf="showData !== 'emailTable'">
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-smile"></i>
                                        <p class="sentiment-score"> {{sentimentData?.positive_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-meh"></i>
                                        <p class="sentiment-score"> {{sentimentData?.neutral_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Neutral</p>
                                    </li>
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-frown"></i>
                                        <p class="sentiment-score"> {{sentimentData?.negative_sentiment?.[0] |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                                <!-- email icons section -->
                                <ul class="list-group list-group-horizontal border" *ngIf="showData === 'emailTable'">
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-smile audioIcons iconSmile" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.positive_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-frown audioIcons iconSad" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.negative_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                            <div class="chart-container border" style="display: none;"> 
                                <!-- <canvas baseChart width="100%" [type]="'line'" [data]="lineChartData"
                                    [options]="lineChartOptions" [legend]="lineChartLegend"
                                    [labels]="lineChartData.labels">
                                </canvas> -->
                            </div>
                            <div class="sentiment-accordin" style="display: none;">
                                <div class="accordion accordion-flush" id="accordionFlushExample1">
                                    <div class="accordion-item accordionClass">
                                        <h2 class="accordion-header" id="flush-headingOne1">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#flush-collapseOne1"
                                                aria-expanded="false" aria-controls="flush-collapseOne"
                                                (click)="sentimentWordsHeading('positive')">
                                                Overall Sentiment Words
                                            </button>
                                        </h2>
                                        <div id="flush-collapseOne1" class="accordion-collapse collapse"
                                            aria-labelledby="flush-headingOne1"
                                            data-bs-parent="#accordionFlushExample1">
                                            <div class="accordion-body">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <ul
                                                            class="nav nav-pills nav-justified border-bottom modalTitileTab">
                                                            <li class="nav-item border">
                                                                <a class="nav-link"
                                                                    [ngClass]="{'active': showSentimentWords === 'positive'}"
                                                                    href="#positive-words" data-bs-toggle="tab"
                                                                    id="positive" role="tab"
                                                                    (click)="sentimentWordsHeading('positive')"
                                                                    aria-current="page">Positive Words</a>
                                                            </li>
                                                            <li class="nav-item border">
                                                                <a class="nav-link"
                                                                    [ngClass]="{'active': showSentimentWords === 'neutral'}"
                                                                    href="#neutral-words" data-bs-toggle="tab"
                                                                    id="neutral" role="tab"
                                                                    (click)="sentimentWordsHeading('neutral')">Neutral
                                                                    Words</a>
                                                            </li>
                                                            <li class="nav-item border">
                                                                <a class="nav-link"
                                                                    [ngClass]="{'active': showSentimentWords === 'negative'}"
                                                                    href="#negative-words" data-bs-toggle="tab"
                                                                    id="negative" role="tab"
                                                                    (click)="sentimentWordsHeading('negative')">Negative
                                                                    Words</a>
                                                            </li>
                                                        </ul>
                                                        <div class="card-body">
                                                            <div class="tab-content">
                                                                <div class="tab-pane"
                                                                    [ngClass]="{'active': showSentimentWords === 'positive', 'show': showSentimentWords === 'positive'}"
                                                                    id="positive-words">
                                                                    <div class="mostUsedWordTab">
                                                                        <p class="data"
                                                                            *ngFor="let word of sentimentPostiveWords; index as i">
                                                                            {{i+1}}. {{word}}
                                                                        </p>
                                                                        <p class="noRecord text-center"
                                                                            *ngIf="sentimentPostiveWords.length == 0">
                                                                            Not Found</p>
                                                                    </div>
                                                                </div>
                                                                <div class="tab-pane"
                                                                    [ngClass]="{'active': showSentimentWords === 'neutral', 'show': showSentimentWords === 'neutral'}"
                                                                    id="neutral-words">
                                                                    <div class="mostUsedWordTab">
                                                                        <p class="data"
                                                                            *ngFor="let word of sentimentNeutralWords; index as i">
                                                                            {{i+1}}. {{word}}
                                                                        </p>
                                                                        <p class="noRecord text-center"
                                                                            *ngIf="sentimentNeutralWords.length == 0">
                                                                            Not Found</p>
                                                                    </div>
                                                                </div>
                                                                <div class="tab-pane"
                                                                    [ngClass]="{'active': showSentimentWords === 'negative', 'show': showSentimentWords === 'negative'}"
                                                                    id="negative-words">
                                                                    <div class="mostUsedWordTab">
                                                                        <p class="data"
                                                                            *ngFor="let word of sentimentNegativeWords; index as i">
                                                                            {{i+1}}. {{word}}
                                                                        </p>
                                                                        <p class="noRecord text-center"
                                                                            *ngIf="sentimentNegativeWords.length == 0">
                                                                            Not Found</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="d-flex align-items-center justify-content-center mt-2">
                            <i class="fa-regular fa-face-meh audioIcons iconMeh" *ngIf="sentimentData.sentiment=='Neutral'" ></i>
                                <i class="fa-regular fa-face-smile audioIcons iconSmile" *ngIf="sentimentData.sentiment=='Positive'" ></i>
                                <i class="fa-regular fa-face-frown audioIcons iconSad" *ngIf="sentimentData.sentiment=='Negative'"></i>
                        </div>
                        <div class="col-12 px-3">
                            <div class="transcriptTab">
                                <p [innerHTML]="sentimentData['sentiment_summary']"></p>
                            </div>
                       </div>
                    </div>
                    <!-- email icon section -->
                    <!-- <div class="tab-content" *ngIf="showData == 'emailTable'">
                        <div class="card">
                            <div class="sentiment-container-emoji">
                                <ul class="list-group list-group-horizontal border">
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-smile audioIcons iconSmile" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.positive_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item">
                                        <i class="fa-regular fa-face-frown audioIcons iconSad" aria-hidden="true"></i>
                                        <p class="sentiment-score">{{sentimentData?.negative_sentiment | number:
                                            '1.1-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- Email Escalte Modal Window -->
    <div class="modal fade" id="emailEscalateModal" tabindex="-1" aria-labelledby="emailEscalateModal"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="emailEscalateModalLabel">Email Template</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <!-- Dialogue Contents -->
                    <div class="tab-content escalate-modal-tab-content">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="transcriptTab emailTableTranscriptTab"
                            *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emailfrom">
                            <span><b>From: </b> {{emailData[fileIndex]?.emailfrom}}</span>
                        </div>
                        <div class="transcriptTab email-transcriptTab"
                            *ngIf=" showData == 'emailTable' && emailData[fileIndex]?.emailto.length > 0 ">
                            <b>To: </b>
                            <ul class="emailTableTranscriptTab"
                                *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                <span> {{to}}</span>
                            </ul>
                        </div>
                        <div class="transcriptTab"
                            *ngIf="showData == 'emailTable' && emailData[fileIndex]?.emailsubject">
                            <ul class="emailTableTranscriptTab">
                                <span> <b>Subject: </b> {{emailData[fileIndex]?.emailsubject}}</span>
                            </ul>
                        </div>
                        <div class="transcriptTab" *ngIf="dialogueList">
                            <ul class="ulTranscript-textRecords"
                                *ngFor="let dialog of dialogueList | search: searchText; index as i">
                                <li class="keywordLi">{{dialog}}</li>
                            </ul>
                        </div>
                        <div class="transcriptTab" *ngIf="!dialogueList">
                            <p class="noRecord text-center">No records found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Email Replay Modal Window -->
    <div class="modal fade" id="emailReplayModal" tabindex="-1" aria-labelledby="emailReplayModal" aria-hidden="true">
        <div class="modal-dialog   modal-lg" [ngClass]="{'full-screen':metricFullscreen}">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="emailReplayModalLabel">Bot Reply Email</h4>
                    <span>
                        <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                        <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                    </span>
                   
                </div>
                <div class="modal-body">
                      <!-- AI Reply Contents -->
                  <div class="tab-content escalate-modal-tab-content">
                    <div>
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="row">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary updateBtn float-end"    (click)="sendMailCustomer()">Send</button>
                         </div>
                        </div>
                   <form [formGroup]="mailSendForm">
                    <div class="row g-6 align-items-center py-1">
                      <div class="col-1">
                        <label  class="col-form-label">To</label>
                      </div>
                      <div class="col-5">
                          <input type="text" formControlName="to" value="{{sentimentData?.customer_mail_id}}"   class="form-control float-end">
                          <span class="text-danger"
                          *ngIf="submitemail && mailSendForm.controls['to'].invalid && mailSendForm.controls['to'].dirty && mailSendForm.hasError('required','to')">
                          Please enter to email.
                      </span>
                        </div>
                    </div>  
                    <div class="row g-6 align-items-center py-1">
                      <div class="col-1">
                        <label  class="col-form-label">From</label>
                      </div>
                      <div class="col-5">
                          <input type="text" formControlName="from" value="{{sentimentData?.agent_mail_id}}"   class="form-control float-end">
                      </div>
                    </div> 
                   
                    
                    <div class="row">
                        <div class="col-1">
                            <label  class="col-form-label">Attachment</label>
                          </div>
                      <div class="col-5">
                        <span class="float-start"  tooltip="Upload Only .pdf, .doc, .jpg files" [options]="myOptions">
                     <input type="file" placeholder="Attachment" #fileUpload class="form-control" accept=".pdf, .doc, .jpg "
                    (click)="clearFile($event)"  (change)="onFileSelected($event)" multiple="multiple">
                </span>
                          
                     
                          <!-- <ng-container *ngFor="let item of selectedFiles">
                            <a [href]="item.base64">
                              <img [src]="item.base64" width="200px" height="150px" />
                            </a>
                          </ng-container> -->
                        </div>
                    </div>
                    <div class="row g-6 align-items-center py-1">
                        <div class="col-1">
                          <label  class="col-form-label">Subject</label>
                        </div>
                        <div class="col-3">
                            <input type="text" formControlName="subject" value=""    class="form-control float-end">
                            <span class="text-danger"
                            *ngIf="submitemail && mailSendForm.controls['subject'].touched && mailSendForm.controls['subject'].invalid && mailSendForm.controls['subject'].hasError('required')">
                            Please enter to email subject.
                        </span>
                      </div> 
                    
                    </div>
                    <div class="row mail-content-section">
                      <div class="col">
                           <angular-editor  formControlName="body" id="htmlContent"
                              name="htmlContent" [config]="editorConfig"></angular-editor>
                              <!-- <span style="font-size:.9rem;" [innerHTML]="changeNewLine(sentimentData?.ai_response?.reply_body)"> </span> -->
                              <!-- <div class="transcriptTab" ></div> -->
                              <span class="text-danger"
                              *ngIf="submitemail && mailSendForm.controls['body'].touched && mailSendForm.controls['body'].invalid && mailSendForm.controls['body'].hasError('required')">
                              Please enter to mail content.
                          </span>
                     </div>
                    </div>
                   </form> 
                    </div>
                    <!-- Customer Mail Contents -->
                    <div class="px-2 py-2">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="transcriptTab emailTableTranscriptTab"
                            *ngIf="showData == 'emailTable' && sentimentData?.from_email">
                            <span><b>From: </b> {{sentimentData?.customer_mail_id}}</span>
                        </div>
                        <!-- <div class="transcriptTab email-transcriptTab"
                            *ngIf=" showData == 'emailTable' && sentimentData?.to_email">
                            <b>To: </b> {{sentimentData?.to_email}}
                              <ul class="emailTableTranscriptTab"
                                *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                <span> {{to}}</span>
                            </ul> 
                        </div> -->
                        <div class="transcriptTab email-transcriptTab"
                        *ngIf=" showData == 'emailTable'">
                            <!-- <ul class="emailTableTranscriptTab"> -->
                                <span> <b>Subject: </b> {{sentimentData?.subject}}</span>
                            <!-- </ul> -->
                        </div>  
                       <div class="transcriptTab" >
                          <span style="font-size:.9rem;" [innerHTML]="changeNewLine(sentimentData?.customer_mail)"> </span>
                       </div>
                    </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
    <!-- translate modal window -->
    <div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="translateModal">
        <div class="modal-dialog modal-dialog-scrollable modal-xl transcriptModalWindow">
            <div class="modal-content translate-modal">
                <div class="modal-header">
                    <h4 class="modal-title">Translate Language</h4>
                    <div class="modal-header-second-part">
                        <i class="fa-solid fa-xmark exitIcon close " title="Close" data-bs-dismiss="modal"
                            aria-label="Close" (click)="clearTranslateModalData()"></i>
                    </div>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="text-center translate-heading">
                        <h4><b>{{displayName}} - Translate Text</b></h4>
                    </div>
                    <div class="container-fluid translate-container">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group language-form-group">
                                    <b class="from">From: </b>
                                    <ng-select [(ngModel)]="selectedTranslate_1" name="choosedLanguage"
                                        (change)="translateTextData(selectedTranslate_1)" class="lg-select-transcript"
                                        placeholder="" [clearable]="false" [readonly]="true" [attr.disabled]="true">
                                        <ng-option *ngFor="let data of tranlateLanguages" title="{{data.lang}}"
                                            [value]="data.value">{{data.lang}}</ng-option>
                                    </ng-select>
                                </div>

                                <div class="card translate-card">
                                    <!-- <div class="table-responsive">
                                            <table class="table">
                                                <thead class="tblHead">
                                                    <tr>
                                                        <th class="speaker-name-tbl-head">Speaker</th>
                                                        <th>Transcript</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="translateResponseData_original[0]?.spanish_edited_text">
                                                    <tr *ngFor="let result of translateResponseData_original; index as i">
                                                        <td class="speakerName">{{result?.display_speaker}}</td>
                                                        <td>{{result?.spanish_edited_text}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> -->
                                    <ul class="ulTranscript-textRecords"
                                        *ngFor="let dialog of translateResponseData_original | search: searchText; index as i">
                                        <li class="keywordLi">{{dialog}}</li>
                                    </ul>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <i *ngIf="translateSpinner"
                                    class="fa fa-spinner fa-pulse fa-3x fa-fw translate-spinner"></i>
                                <span class="sr-only">Loading...</span>
                                <div class="form-group">
                                    <b class="from">To: </b>
                                    <ng-select [(ngModel)]="selectedTranslate" name="choosedLanguage"
                                        (change)="translateTextData(selectedTranslate)" class="lg-select-transcript"
                                        placeholder="" [clearable]="false">
                                        <ng-option *ngFor="let data of tranlateLanguages" title="{{data.lang}}"
                                            [value]="data.value">{{data.lang}}</ng-option>
                                    </ng-select>
                                </div>
                                <div class="card translate-card">
                                    <!-- <div class="table-responsive">
                                        <table class="table">
                                            <thead class="tblHead">
                                                <tr>
                                                    <th class="speaker-name-tbl-head">Speaker</th>
                                                    <th>Transcript</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="translateResponseData_original[0]?.spanish_edited_text">
                                                <tr *ngFor="let result of translateResponseData; index as i">
                                                    <td class="speakerName">{{result?.display_speaker}}</td>
                                                    <td>{{result?.edited_text}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> -->
                                    <ul class="ulTranscript-textRecords"
                                        *ngFor="let dialog of translateResponseData | search: searchText; index as i">
                                        <li class="keywordLi">{{dialog}}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-md-6 offset-md-3">
        <div class="card modalCard2" id="sentimentCard3" style="display:none">
            <div class="card-header">
                <p class="sentiment-header"> Sentiment</p>
            </div>
            <table id="sentiment-table-report">
                <tbody>
                    <tr>
                        <td>
                            <div class="card-body">
                                <ul class="list-group list-group-horizontal">
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-smile" class="fa-regular fa-face-smile"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.positive_sentiment |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Positive</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-meh" class="fa-regular fa-face-meh"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.neutral_sentiment |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Neutral</p>
                                    </li>
                                    <li class="list-group-item secondList">
                                        <i id="fa-face-frown" class="fa-regular fa-face-frown"></i>
                                        <p class="sentiment-score">
                                            {{infoDetails?.negative_sentiment |
                                            number:'1.0-1'}}%</p>
                                        <p class="sentiment-name">Negative</p>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div> -->
</div>

<!-- delete modal for Delete table record-->
<div class="modal fade deleteModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="exampleModalLabel">Delete File</h4>
                <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"></i>
            </div>
            <div class="modal-body">
                Are you sure, you want to delete?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
                <button type="button" class="btn btn-danger" (click)="deleteSelectRecord(getRecordIndex)"
                    data-bs-dismiss="modal">Yes</button>
            </div>
        </div>
    </div>
</div>

    <!-- QA Metrics Modal Window -->
    <div class="modal fade" id="qaMetricsModal" tabindex="-1" aria-labelledby="qaMetricsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-xl"  [ngClass]="{'full-screen':metricFullscreen}">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="qaMetricsModalLabel">Metric Details</h4>
                    <span>
                    <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                    <i class="fa-solid fa-xmark exitIcon " data-bs-dismiss="modal" aria-label="Close"
                        (click)="clearMetricsModalData()"></i>
                    </span>
                </div>
                <div class="modal-body">
                    <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                    <div class="card modalCard"  >
                        <div class="card-header">
                            <p>Agent QA Score - {{QAMetricsData?.qa_score |
                                number:'1.0-1'}}</p>  
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                               <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="6" class="text-center">Machine Scores based on QA Metric</th>
                                            <th colspan="2" class="text-center">Manual Score</th>
                                        </tr>
                                        <tr>
                                            <th>Configured QA Parameter</th>
                                            <th>Configured <br>QA Score</th>
                                            <th>Configured Keywords</th>
                                            <th>Machine Score <br>for Agent</th>
                                             <th>Error type</th>
                                            <th>Matched keywords/Explanation</th>
                                            <th>QA Analyst <br>Manual Score</th>
                                            <th>QA Analyst Manual Comments</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngIf="!spinner">
                                        
                                         <tr class="text-center" *ngIf="QAMetricsData?.audit_details.length == 0">
                                            <td colspan="8">
                                                <p class="noRecord">No Records Found</p>
                                            </td>
                                        </tr>  
                                        <tr *ngIf="metricsMatches.length">
                                            <td></td>
                                            <td class="text-center">{{QAMetricsData?.total_config_score}}</td>
                                            <td></td>
                                            <td class="text-center">{{QAMetricsData?.actual_score}}</td>
                                            <td></td>
                                            <td></td>
                                            
                                            <!-- <td>{{metricsTotal}}</td> -->
                                            <td>{{QAMetricsData?.total_manual_score}}</td>
                                            <td></td>
                                        </tr> 
                                        <tr *ngFor="let call of metricsMatches; index as i">
                                            <td>{{call?.qa_param}}</td>
                                            <td style="text-align: center;" >{{call?.config_score}}</td>
                                            <td  appReadMore [toggle]="true" [limit]="55" >{{call?.config_keywords}}</td>
                                            <td style="text-align: center;" >{{call?.machine_score | number : '1.0-1'}}
                                            </td>
                                            <td style="text-align: center;" >{{call?.error_type}}</td>
                                            <!-- <td style="text-align: center;" >{{call?.matched_percentage | number
                                                :'1.0-1'}}%</td> -->
                                            <td  >{{call?.matched_keywords}}
                                                <p class="text-center" *ngIf="!call?.matched_keywords">-</p>
                                            </td>
                                            <td (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex">
                                                <i class="fa-regular fa-pen-to-square"></i> 
                                                <p class="text-center">{{call?.manual_score}}</p>
                                                <!-- <p class="text-center" *ngIf="metricsTotalScoreArray[i]">{{metricsTotalScoreArray[i]}}</p>
                                                <p class="text-center" *ngIf="metricsTotalScoreArray[i]==''">-
                                                </p> -->
                                            </td>
                                            <td *ngIf="i === getMetricsIndex">
                                                <input type="text" #restrictScore [(ngModel)]="metricsMScore"
                                                      class="form-control" max="{{call?.manual_score}}"
                                                      (keyup)="sendMetricIndex(i, 'score',$event)">
                                                <!-- <input type="text" #restrictScore [(ngModel)]="metricsMScore"
                                                      class="form-control" max="{{call?.score}}"
                                                    (keyup)="sendMetricIndex(i, 'score')"> -->
                                                     <div *ngIf="metricsMScore_valid">
                                                        <span class="error" style="color:red;">{{metricsMScore_valid_text}}</span>
                                                    </div>  
                                                     
                                            </td>
                                            <td (click)="showManualField(i)"
                                                *ngIf="i !== getMetricsIndex">
                                                <i class="fa-regular fa-pen-to-square"></i>  
                                                 <p class="text-center">{{call?.manual_score_comments==0 ? "": call?.manual_score_comments}}</p> 
                                                <!-- <p *ngIf="metricsCommentsArray[i]">{{metricsCommentsArray[i]}}</p>
                                                <p class="text-center" *ngIf="!metricsCommentsArray[i]">-
                                                </p> -->
                                            </td>
                                            <td *ngIf="i === getMetricsIndex">
                                                 <textarea type="text" [(ngModel)]="metricsMComments"
                                                    class="form-control"
                                                    (change)="sendMetricIndex(i, 'comment',$event)"></textarea> 
                                            </td>
                                        </tr>
                                        <tr *ngIf="metricsMatches.length">
                                            <td><b>Total Scores</b></td>
                                            <td class="text-center"> {{QAMetricsData?.total_config_score}}</td>
                                            <td></td>
                                            <td class="text-center">{{QAMetricsData?.actual_score}} </td>
                                            <td></td>
                                            <td></td>
                                            <td>{{QAMetricsData?.total_manual_score}} </td>
                                            <td></td>
                                        </tr>  
                                    </tbody>
                                </table>  
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light cancelBtn" data-bs-dismiss="modal"
                        (click)="clearMetricsModalData()">Cancel</button>
                    <button type="button" class="btn btn-primary updateBtn" (click)="updateMetricsManualField()"
                        [disabled]="!showManualInput" 
                         >Update</button>
                </div>
            </div>
        </div>
    </div>

     <!-- Call Category Modal Window -->
    <div class="modal fade" id="callCategoryModal" tabindex="-1" aria-labelledby="callCategoryModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="callCategoryModalLabel">Category</h4>
                    <i class="fa-solid fa-xmark exitIcon " (click)="clearCallCategory()" data-bs-dismiss="modal"
                        aria-label="Close"></i>
                </div>
                <div class="modal-body">
                    <div class="card modalCard">
                        <div class="card-header">
                            <p>Category Details</p>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>Keywords</th>
                                        <th>Matched Keywords</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="text-center" *ngIf="call_category.length === 0 else categoryList">
                                        <td colspan="3">
                                            <p class="noRecord">No Records Found</p>
                                    </tr>
                                    <ng-template #categoryList>
                                    <ng-container *ngFor="let call of call_category; index as i">
                                    <tr>
                                        <td>{{call?.category_name}}</td>
                                        <td>{{call?.keywords.join(', ')}}</td>
                                        <td>{{call?.matched_keywords.join(', ')}} <p class="text-center"
                                                *ngIf="!call?.matched_keywords">-</p>
                                        </td>
                                    </tr>
                                    </ng-container>
                                    </ng-template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


      <!-- Email  Modal Window -->
      <div class="modal fade" id="emailBodyModal" tabindex="-1" aria-labelledby="emailBodyModal"
      aria-hidden="true">
      <div class="modal-dialog modal-xl"  [ngClass]="{'full-screen':metricFullscreen}">
          <div class="modal-content">
              <div class="modal-header">
                  <h4 class="modal-title" id="emailEscalateModalLabel">Email</h4>
                  <span>
                  <i class="fa metricFullscreen" [ngClass]="{'fa-down-left-and-up-right-to-center':metricFullscreen,'fa-up-right-and-down-left-from-center':!metricFullscreen}"  (click)="metricFullscreen = !metricFullscreen"></i>&nbsp;&nbsp;
                  <i class="fa-solid fa-xmark exitIcon " (click)="clearKeywordDetails()" data-bs-dismiss="modal"
                      aria-label="Close"></i>
                 </span>
              </div>
              <div class="modal-body">
                  <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                  <span class="sr-only">Loading...</span>
                  <!-- <ul class="nav nav-pills nav-justified border-bottom modalTitileTab" role="tablist">
                     <li class="nav-item border-end border-bottom border-2">
                        <a class="nav-link" [ngClass]="{'active':showModal === 'agentResponse'}" href="#nav-summary"
                            data-bs-toggle="tab" role="tab" id="summary" (click)="modalHeading('agentResponse')"
                            >Agent Response</a>
                    </li>
                    <li class="nav-item border-end border-bottom border-2">
                        <a class="nav-link" [ngClass]="{'active':showModal === 'customerMail'}"   href="#nav-transcript"
                            data-bs-toggle="tab" id="transcript" role="tab" (click)="modalHeading('customerMail')"
                            >Customer Mail</a>
                    </li>
                    </ul>  -->
                
                      <!-- Customer Mail Contents -->
                      <div class="tab-content escalate-modal-tab-content">
                        <div class="tab-pane"
                        [ngClass]="{'active': showModal === 'customerMail', 'show': showModal === 'customerMail'}">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                        <div class="transcriptTab emailTableTranscriptTab"
                            *ngIf="showData == 'emailTable' && customerEmailtData?.from_email">
                            <span><b>From: </b> {{customerEmailtData?.customer_mail_id}}</span>
                        </div>
                        <!-- <div class="transcriptTab email-transcriptTab"
                            *ngIf=" showData == 'emailTable' && sentimentData?.to_email">
                            <b>To: </b> {{sentimentData?.to_email}}
                              <ul class="emailTableTranscriptTab"
                                *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                <span> {{to}}</span>
                            </ul> 
                        </div> -->
                        <div class="transcriptTab email-transcriptTab"
                        *ngIf=" showData == 'emailTable'">
                            <!-- <ul class="emailTableTranscriptTab"> -->
                                <span> <b>Subject: </b> {{customerEmailtData?.subject}}</span>
                            <!-- </ul> -->
                        </div>  
                       <div class="transcriptTab" >
                          <span style="font-size:.9rem;" [innerHTML]="changeNewLine(customerEmailtData?.customer_mail)"> </span>
                       </div>
                        </div>
                        <div class="tab-pane"
                        [ngClass]="{'active': showModal === 'agentResponse', 'show': showModal === 'agentResponse'}">
                        <i *ngIf="spinner" class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                        <span class="sr-only">Loading...</span>
                       
                        <!-- <div class="transcriptTab email-transcriptTab"
                            *ngIf=" showData == 'emailTable' && sentimentData?.to_email">
                            <b>To: </b> {{sentimentData?.to_email}}
                              <ul class="emailTableTranscriptTab"
                                *ngFor="let to of emailData[fileIndex]?.emailto; index as to_i">
                                <span> {{to}}</span>
                            </ul> 
                        </div> -->
                      
                       <div class="transcriptTab" >
                          <span style="font-size:.9rem;" [innerHTML]="changeNewLine(customerEmailtData?.agent_response)"> </span>
                       </div>
                        </div>
                   </div>
                </div>
          </div>
      </div>
  </div>